var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GameTemplate',{attrs:{"game":_vm.game,"platform":_vm.platform},on:{"add-score":_vm.addScore,"go-to-platform":_vm.goToPlatform}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }